import { useEffect } from "react";

const DEFAULT = {
    title: "Thooyra Technologies — Custom ERP, Accounting & Business Software Development Company in Chennai",
    description:
        "Thooyra Technologies is a Chennai-based software development company building custom ERP systems, accounting software, SaaS platforms, mobile apps, cloud solutions and business automation for growing companies.",
    canonical: "https://www.thooyra.in/",
};

function setMeta(name, content, attr = "name") {
    if (!content) return;
    let el = document.head.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content);
}

function setCanonical(href) {
    let el = document.head.querySelector('link[rel="canonical"]');
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

export default function useSEO({ title, description, path } = {}) {
    useEffect(() => {
        const finalTitle = title || DEFAULT.title;
        const finalDesc = description || DEFAULT.description;
        const finalCanonical = path
            ? `https://www.thooyra.in${path}`
            : DEFAULT.canonical;

        document.title = finalTitle;
        setMeta("description", finalDesc);
        setMeta("og:title", finalTitle, "property");
        setMeta("og:description", finalDesc, "property");
        setMeta("og:url", finalCanonical, "property");
        setMeta("twitter:title", finalTitle);
        setMeta("twitter:description", finalDesc);
        setCanonical(finalCanonical);
    }, [title, description, path]);
}
